import axios from 'axios';

let prefix = "/creep"

const CreepApi = {
	listCreep(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getCreepInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	getCreepTypeRef(payload) {
		return axios.get(prefix + "/get-type", { params: payload })
	},
	archiveCreep(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createCreep(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateCreep(payload) {
		return axios.post(prefix + "/update", payload)
	},
	selectCreepStat(payload) {
		return axios.post(prefix + "/select-stat", payload)
	},
}

export default CreepApi;